// extracted by mini-css-extract-plugin
export default {"loadingDiv":"style_loadingDiv__pq1UC"};